import React, { useEffect, useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage } from "react-intl";
import { fetchEnvironmentVariables } from "../../api/adminService";
function AdminEnvironmentVariables() {
    var ky = useOkapiKy();
    var _a = useState([]), environmentVariables = _a[0], setEnvironmentVariables = _a[1];
    useEffect(function () {
        fetchEnvironmentVariables(ky).then(function (response) {
            setEnvironmentVariables(response.environmentVariables);
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.description" }),
        React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.title.environment.variables", tagName: "h1" }),
        React.createElement("ul", null, environmentVariables.map(function (environmentVariable) { return (React.createElement("li", { key: environmentVariable.name },
            React.createElement("strong", null,
                environmentVariable.name,
                ":"),
            " ",
            environmentVariable.value)); }))));
}
export default AdminEnvironmentVariables;
